var inlineError = (function() {
  
  return {
    showError: showError
  };
  
  function showError(fieldName, fieldError, errorName, errorMessage) {
    if (fieldError) {
      fieldError.remove();
    }
    fieldName.classList.remove("error-border");
    fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="' + errorName + '">' + errorMessage + '</span>');
    fieldName.classList.add("error-border");
  }

})();